import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class ExpandingBlurb extends React.Component {
    static propTypes = {
        text: PropTypes.string,
        htmlText: PropTypes.string,
        active: PropTypes.bool,
        position: PropTypes.string
    };

    state = {
        show: false
    };

    toggle = () => {
        this.setState({
            show: !this.state.show
        });
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.active) {
            this.setState({
                show: false
            });
        }
    }

    render() {
        if (!this.props.text && !this.props.htmlText) {
            return (<div />);
        }
        const classes = classNames(`expanding-blurb ${this.props.position}`, {
            active: this.props.active,
            show: this.state.show === true,
            hide: this.state.show === false
        });

        return (
            <div
                role="presentation"
                id="expandingBlurb"
                className={classes}
                onClick={this.toggle}
                title="Toggle">
                <div className="text-wrapper">
                    {this.props.htmlText ? <div dangerouslySetInnerHTML={{__html: this.props.htmlText}} /> : <p>{this.props.text}</p>}
                </div>
            </div>
        );
    }
}
